// aes.ts
import CryptoJS from "crypto-js";

export class VueAES128 {
    private static _key = "8881457cc3034a8b9cd9bd23bb59a5c2"; // 16 bytes key

    private static stringToUint8Array(str: string) {
        const arr = new Uint8Array(str.length);
        for (let i = 0; i < str.length; i++) {
            arr[i] = str.charCodeAt(i);
        }
        return arr;
    }

    private static arrayCopy(sourceArray: any, sourceIndex: number, destinationArray: any, destinationIndex: number, length: number) {
        for (let i = 0; i < length; i++) {
            destinationArray[destinationIndex + i] = sourceArray[sourceIndex + i];
        }
    }

    private static getKeyAndIv(key: string): CryptoJS.lib.WordArray {
        var passBytes = this.stringToUint8Array(key);
        var EncryptionkeyBytes = new Uint8Array(16).fill(0); // 0x00으로 초기화 (16 바이트)
        var len = passBytes.length;
        if (len > EncryptionkeyBytes.length) {
            len = EncryptionkeyBytes.length;
        }
        this.arrayCopy(passBytes, 0, EncryptionkeyBytes, 0, len);

        var wordArray = CryptoJS.lib.WordArray.create(EncryptionkeyBytes);
        return wordArray;
    }

    public static encrypt(plainText: string) {
        var keyAndIv = this.getKeyAndIv(this._key);

        const encrypted = CryptoJS.AES.encrypt(plainText, keyAndIv, {
            iv: keyAndIv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return encrypted.toString();
    }

    public static decrypt(cipherText: string) {
        var keyAndIv = this.getKeyAndIv(this._key);
        const decrypted = CryptoJS.AES.decrypt(cipherText, keyAndIv, {
            iv: keyAndIv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}
